import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { LogEntry } from '@/types/LogEntry';
import type { LogLevel } from '@/types/Logger';

interface LogsSnapshot {
  logEntries: LogEntry[];
  logNamespaces: string[];
  logLevel: LogLevel;
}

export const refreshLogsThunk = createAppAsyncThunk<LogsSnapshot>(
  'debug/refreshLogs',
  (_, { extra: { loggerService } }) => ({
    logEntries: loggerService.getRecentLogs(),
    logNamespaces: loggerService.getEnabledPatterns(),
    logLevel: loggerService.getLevel(),
  })
);
